// The three plans as the homepage tells them: the hero's boxes and the
// chapters' title bars both read this, so they always say the same thing.
// Prices and the plan list itself live in backend/plans.py. `art` is the
// plan's drawing.
export const PLANS = [
  {
    key: 'solo',
    name: 'Solo',
    art: 'tierSolo',
    title: 'Quote it. Book it. Know what it earns.',
    body: 'Quoting for film and TV crews who own their own gear. See when every camera, lens and light has paid for itself.',
    onSale: true,
  },
  {
    key: 'filmmaker',
    name: 'Filmmaker',
    art: 'tierProjects',
    title: 'Win the work.',
    body: 'Capture the client’s brief from a link. Build a visual shot list, frame by frame. Everything you need to hire goes straight onto the quote.',
  },
  {
    key: 'teams',
    name: 'Teams',
    art: 'tierProducer',
    title: 'Deliver on the promise.',
    body: 'Bring in a small crew, line up suppliers and send purchase orders, all from the same job.',
  },
];

export const planByKey = (key) => PLANS.find((p) => p.key === key);
